import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Check } from 'lucide-react';
const bonuses = [{
  icon: '🟢',
  num: 1,
  title: 'Calculadora de Honorarios y Gastos',
  desc: 'Sabé exactamente cuánto vale tu hora de trabajo y si cada paciente realmente te conviene.',
  items: ['Fórmula de valor hora mínimo', 'Planilla de registro mensual de ingresos y gastos', 'Calculadora de rentabilidad por paciente']
}, {
  icon: '🔵',
  num: 2,
  title: 'Guía de Entrevistas de Admisión',
  desc: 'El protocolo completo para la primera reunión que te posiciona como profesional de élite desde el minuto cero.',
  items: ['Las 20 preguntas clave para la familia', 'Las 10 preguntas para el equipo técnico', 'Ficha de admisión completa lista para usar', 'Señales de alerta que no podés ignorar']
}, {
  icon: '🟤',
  num: 3,
  title: 'Kit Anti-Burnout del AT',
  desc: 'El protocolo de autocuidado para sostener tu salud mental sin culpa y sin abandonar a tus pacientes.',
  items: ['Los 5 síntomas de burnout que los AT ignoran', 'Protocolo de autocuidado semanal: 10 acciones concretas', 'Test mensual de nivel de desgaste', '5 estrategias de separación emocional trabajo-hogar']
}, {
  icon: '🟡',
  num: 4,
  title: 'Planilla Maestro de Asistencia y Firmas',
  desc: 'El documento que respalda cada sesión y que la Obra Social no puede ignorar al momento de auditar.',
  items: ['Planilla mensual con 20 sesiones lista para imprimir', 'Declaración del tutor legal incluida', 'Los 8 puntos que hacen válida tu planilla ante auditoría', 'Errores frecuentes que invalidan la planilla y cómo evitarlos']
}];
export function BonusSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-28">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="text-center mb-16" data-id="element-29">
        <Gift className="w-12 h-12 text-[#d4af37] mx-auto mb-4" data-id="element-30" />
        <h2 className="text-3xl md:text-4xl font-bold text-white font-heading mb-4 tracking-wider" data-id="element-31">
          LOS 4 BONOS EXCLUSIVOS
        </h2>
        <div className="w-24 h-1 bg-gold-gradient mx-auto rounded-full" data-id="element-32" />
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-33">
        {bonuses.map((bonus, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-gradient-to-br from-[#0f1d36] to-[#0a1628] border border-[#1a2b4c] rounded-2xl p-6 md:p-8 relative overflow-hidden flex flex-col h-full" data-id="element-34">
            {/* Subtle corner highlight */}
            <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#d4af37] opacity-5 rounded-full blur-2xl" data-id="element-35" />

            <div className="flex items-center gap-3 mb-4" data-id="element-36">
              <span className="text-2xl" data-id="element-37">{bonus.icon}</span>
              <div className="text-[#d4af37] text-sm font-bold tracking-widest" data-id="element-38">
                BONO {bonus.num}
              </div>
            </div>

            <h3 className="text-xl font-bold text-white font-heading leading-tight mb-3" data-id="element-39">
              {bonus.title}
            </h3>

            <p className="text-[#a0aec0] mb-6 italic" data-id="element-40">{bonus.desc}</p>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-41">
              {bonus.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-42">
                  <Check className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-43" />
                  <span className="text-[#e2e8f0] text-sm md:text-base" data-id="element-44">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-auto pt-4 border-t border-[#1a2b4c] flex items-center justify-between" data-id="element-45">
              <span className="text-[#a0aec0] line-through decoration-red-500/50" data-id="element-46">
                Valor: $9.990
              </span>
              <span className="text-gold-gradient font-bold text-lg" data-id="element-47">
                HOY GRATIS
              </span>
            </div>
          </motion.div>)}
      </div>
    </section>;
}